import { toast } from "react-toastify";

type ToastHandlerOptions<T> = {
    loadingMessage: string;
    successMessage?: string;
    errorMessage?: string;
    operation: () => Promise<T>;
    onSuccess?: (result: T) => void;
    onError?: (error: any) => void;
    onSettled?: () => void;
    onRedirectMessage?: string;
    onRedirectType?: "success" | "error";
};

export async function toastHandler<T>({
    loadingMessage,
    successMessage,
    errorMessage,
    operation,
    onSuccess,
    onError,
    onSettled,
    onRedirectMessage,
    onRedirectType,
}: ToastHandlerOptions<T>): Promise<T | undefined> {
    const toastId = toast.loading(loadingMessage);

    try {
        const result = await operation();
        toast.update(toastId, {
            render: successMessage,
            type: "success",
            isLoading: false,
            autoClose: 2000,
        });
        onSuccess?.(result);
        toast.dismiss(toastId);
        return result;
    } catch (error: unknown) {
        // Don't show error toast for Next.js redirect errors
        if (error instanceof Error && error.message.includes("NEXT_REDIRECT")) {
            toast.update(toastId, {
                render: onRedirectMessage ?? successMessage,
                type: onRedirectType ?? "success",
                isLoading: false,
                autoClose: 2000,
            });
        } else {
            toast.update(toastId, {
                render:
                    errorMessage ??
                    (error instanceof Error
                        ? error.message
                        : "An error occurred"),
                type: "error",
                isLoading: false,
                autoClose: 5000,
            });
        }
        toast.dismiss(toastId);
        console.error(error);
        onError?.(error);
    } finally {
        onSettled?.();
    }
}
